import Vue from "vue";
import VueRouter from "vue-router";
// import hooks from "./hooks";
import { Loading } from "element-ui";
import config from "@/config";

Vue.use(VueRouter);

const files = require.context("./modules", false, /\.router.js$/);
let routes = [];

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


files.keys().forEach(route => {
  routes.push(...files(route).default);
});
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

//路由守卫
router.beforeEach((to, from, next) => {
  //路由中设置的needLogin字段就在to当中
  if (window.localStorage.getItem("token")) {
    // console.log(window.sessionStorage);
    // console.log(to.path) //每次跳转的路径
    if (to.path === "/login") {
      //登录状态下 访问login.vue页面 会跳到index.vue
      next({ path: config.IS_NEIWANG==="1"?"/":"/search_list" });
    } else {
      let flag =false;
      let menu = window.localStorage.getItem("menu");

        if(menu){
            menu = JSON.parse(menu);

            menu.forEach(function(item, index){
              if(item.url=== to.path){
                flag = true;
                 return false;
              }
              if(item.children){
                  item.children.forEach(function(e, i){
                      if(e.url=== to.path){
                        flag = true;
                        return false;
                      }
                  })
              }
            })
        }else{
          flag = true;
        }
        let arrayUrl = ['/','/idcardcertification','/password','/changephone','/personaldetail'];
        if(arrayUrl.includes(to.path)){
          flag = true;
        }

        if(flag){
          next();
        }else{
          next({path:"/login"});
        }

    }
  } else {
    // 如果没有session ,访问任何页面。都会进入到 登录页
    if (to.path === "/login") {
      // 如果是登录页面的话，直接next() -->解决注销后的循环执行bug
      next();
    } else {
      // 否则 跳转到登录页面
      next({ path: "/login" });
    }
  }
});
// Object.values(hooks).forEach(hook => {
//   router.beforeEach(hook.bind(router));
// });

// 路由进入给loading
const loadingInstance = Loading.service({ text: "加载中" });
router.afterEach(() => {
  loadingInstance.close();
});

export default router;
